<template>
  <div class="share-link-container">
    <div class="share-message">
      <span>Share this link with your group:</span>
      <div class="share-url-container">
        <input 
          type="text" 
          :value="shareUrl" 
          readonly 
          class="share-url-input"
          ref="urlInput"
        />
        <button @click="copyToClipboard" class="copy-button" :class="{ copied: copied }">
          {{ copied ? 'Copied!' : 'Copy' }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ShareLink',
  props: {
    instanceId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      copied: false
    };
  },
  computed: {
    shareUrl() {
      return `${window.location.origin}/${this.instanceId}`;
    }
  },
  methods: {
    async copyToClipboard() {
      try {
        await navigator.clipboard.writeText(this.shareUrl);
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      } catch (err) {
        // Fallback for older browsers
        this.$refs.urlInput.select();
        document.execCommand('copy');
        this.copied = true;
        setTimeout(() => {
          this.copied = false;
        }, 2000);
      }
    }
  }
};
</script>

<style scoped>
.share-link-container {
  margin-bottom: 20px;
  padding: 15px;
  background-color: #f8f9fa;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.share-message {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.share-message span {
  font-weight: 500;
  color: #333;
}

.share-url-container {
  display: flex;
  gap: 10px;
  align-items: center;
}

.share-url-input {
  flex: 1;
  min-width: 0;
  width: 100%;
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  background-color: white;
  color: #333;
  box-sizing: border-box;
}

.share-url-input:focus {
  outline: none;
  border-color: #3498db;
}

.copy-button {
  margin: 0;
  padding: 8px 16px;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.copy-button:hover {
  background-color: #2980b9;
}

.copy-button.copied {
  background-color: #27ae60;
}

.copy-button.copied:hover {
  background-color: #229954;
}

@media (max-width: 600px) {
  .share-url-container {
    flex-direction: column;
    align-items: stretch;
  }

  .copy-button {
    width: 100%;
    margin: 0;
    min-height: 44px;
  }
}
</style>

